import axios from 'axios';
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

import { Locale } from '~/i18n/i18n.config';

export function cn (...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const sleep = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const formatDate = (date: string, _lang: Locale) => {
  const dateParsed = new Date(date);
  return new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
    timeZone: 'Europe/Madrid'
  }).format(dateParsed);
};

export const decodeJWT = (
  token: string
): {
  exp: number
  iat: number
  sub: string
  type: 'access' | 'refresh'
} => {
  const payload = token.split('.')[1] || '';
  return JSON.parse(Buffer.from(payload, 'base64').toString('utf8'));
};

export const saveFile = async (url?: string, filename?: string) => {
  if (!url || !filename) {
    throw new Error('URL and filename are required');
  }
  try {
    // Create a temporary link element
    const link = document.createElement('a');
    let blob: Blob;

    if (url.includes('https://')) {
      const response = await axios.get(url, {
        responseType: 'blob'
      });
      blob = new Blob([response.data]);
    } else {
      throw new Error('File is not downloadable');
    }

    link.href = window.URL.createObjectURL(blob);
    link.download = filename;

    // Trigger the download
    link.click();

    // Clean up the temporary link element
    window.URL.revokeObjectURL(link.href);
    link.remove();
  } catch (error) {
    throw new Error('Error downloading file:', error as ErrorOptions);
  }
};
